module.exports = require('./helpers/bundle-url').getBundleURL('g9U4b') + "logo-dark.eefe0b7f.svg";